export enum MultiCompanyLogic {
  PercentageOfMiles = 0,
  LargestPercentage = 1,
  LeasedEmployees = 2,
  BasedOnDaysLogs = 3,
  EmployeeCompanyWithOverride = 4,
  NoChanges = 5
}

export const MultiCompanyLogicMapping: Record<MultiCompanyLogic, string> = {
  [MultiCompanyLogic.PercentageOfMiles]: '% of Miles (Everything)',
  [MultiCompanyLogic.LargestPercentage]: '% of Miles, Non-Earned => Largest Percentage',
  [MultiCompanyLogic.LeasedEmployees]: 'Single Company/Leased Employees',
  [MultiCompanyLogic.BasedOnDaysLogs]: `Based on Day's logs`,
  [MultiCompanyLogic.EmployeeCompanyWithOverride]: 'Employee Company with Override',
  [MultiCompanyLogic.NoChanges]: 'No Changes'
};

export const MultiCompanyShowPayrollCompany: MultiCompanyLogic[] = [
  MultiCompanyLogic.NoChanges,
  MultiCompanyLogic.EmployeeCompanyWithOverride
];
